// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"544bf4dc","239":"7470cd02","453":"dcbf455b","455":"6fba1bfd"}[chunkId] + ".chunk.js";
};